import { BoldTextButton } from "thrive-components";
import { getContentPostTitle } from "../notificationTitles.service";


export interface IContentPostTitle {
    parentList?: {
        id?: number;
        title: string;
        link: string;
    }
    user: string;
    isPopOut?: boolean
}

const ContentPostTitle = ({parentList, user, isPopOut}: IContentPostTitle ) => {
    const {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle} = getContentPostTitle({parentList, user, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}

            <BoldTextButton
                ariaLabel={contentLinkAriaLabel}
                link={contentLink}
                text={contentLinkTitle}
            />
        </span>
    );
};
export default ContentPostTitle;
